import React from 'react';
import { IonItem } from '@ionic/react';
import SectionCard from '@/components/SectionCard';
import ObfuscatedEmail from '@/components/ObfuscatedEmail';

interface ListingManagersBlockProps {
  managerEmails: string[];
}

/**
 * Bottom-of-page card listing the topic's listing managers so a viewer can
 * contact them. Emails are rendered with anti-scrape defenses (see
 * ObfuscatedEmail). Renders nothing when no manager emails were returned.
 */
const ListingManagersBlock: React.FC<ListingManagersBlockProps> = ({
  managerEmails,
}) => {
  if (managerEmails.length === 0) {
    return null;
  }
  return (
    <SectionCard
      title={managerEmails.length > 1 ? 'Listing managers' : 'Listing manager'}
    >
      {managerEmails.map((email, i) => (
        <IonItem
          key={email}
          lines={i === managerEmails.length - 1 ? 'none' : 'inset'}
          data-testid="manager-email-item"
        >
          <ObfuscatedEmail email={email} />
        </IonItem>
      ))}
    </SectionCard>
  );
};

export default ListingManagersBlock;
